const GUID = {
    SP: "_",
    MenSP: "`",
}

export { GUID };
export default GUID;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiConstants/sgiCommonConstant.js